import React from "react";
import UserApprovalRow from "./user-approval-Row";
import * as requisitionTypes from "../../../../general/paper-state";
import { connect } from "react-redux";
import { buildApprovalRows, legacyRoute } from "./approval-rows";

class UserApprovalsTable extends React.Component {
  render() {
    const rows = buildApprovalRows({
      route: this.props.route || legacyRoute(this.props.steps),
      approvals: this.props.approvals,
      paperState: this.props.state,
      userEmail: this.props.userEmail,
      canApprove: this.props.canApprove,
    }).map((row) => (
      <UserApprovalRow
        key={row.key}
        date={row.date}
        email={row.email}
        fallbackNames={row.fallbackNames}
        orderNumber={row.order}
        firstName={row.firstName}
        lastName={row.lastName}
        approved={row.approved}
        infoStep={row.infoStep}
        canApprove={row.canApprove}
        calling={row.calling}
        paperId={this.props.paperId}
        paper={this.props.paper}
        onReject={this.props.onReject}
        onApprove={this.props.onApprove}
        showApprovingProgress={this.props.showApprovingProgress}
        allApproved={requisitionTypes.isApproved(this.props.state)}
      />
    ));

    return (
      <div>
        <div className="ds-table-card ds-table-card--flat"><table className="table table-hover">
          <tbody>
            <tr>
              <th />
              <th>Nume</th>
              <th>Prenume</th>
              <th>Email</th>
              <th>Stare aprobare</th>
              <th>Data</th>
            </tr>
            {rows}
          </tbody>
        </table></div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userEmail: state.login.user.email,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserApprovalsTable);
